<template>
  <div>
    <form class="topform" @submit="sendEmail($event)">
      <p>
        <label style="margin-right:10px">Do:</label>
        <label v-for="item in emails" :key="item">
          <span @click="remove(item)">{{ item }}</span>
        </label>
      </p>
      <p>
        <label>Temat:</label>
        <input
          v-model="subject"
          id="topic"
          type="text"
          required
          minlength="1"
        />
      </p>
      <p>
        <label>Wiadomość:</label>
      </p>
      <p>
        <textarea
          id="message"
          rows="10"
          maxlength="6000"
          minlength="1"
          required
          style="width: 100% "
          ref="my_input"
          v-model="text"
        ></textarea>
      </p>
      <button class="buttonm" type="submit">Wyślij</button>
    </form>
  </div>
</template>

<script>
import axios from "../axios";
export default {
  data() {
    return {
      subject: "",
      text: "",
      alert: "",
    };
  },
  computed: {
    emails() {
      return this.$store.getters.getMails;
    },
  },
  methods: {
    remove(email) {
      this.$store.commit("REMOVE_EMAIL", email);
    },
    sendEmail(event) {
      event.preventDefault();
      if (this.emails.length === 0) {
        alert(
          "Wróc do ekranu 'użytkownicy' i zaznacz osoby, do których chcesz wysłać wiadomość"
        );
      } else {
        const message = {
          members: this.emails,
          subject: this.subject,
          text: this.text,
        };
        const token = localStorage.getItem("token");
        axios
          .post(
            "api/management/users/sendmail",
            message,
            {
              headers: { "x-access-token": `${token}` },
            }
          )
          .then(() => {
            alert("Pomyślnie przesłano wiadomość!");
            this.subject = "";
            this.text = "";
            this.$store.commit("UNCHECK_ALL_USERS");
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    },
  },
  name: "Mail",
};
</script>

<style scoped>
span {
  margin-right: 20px;
  display: inline-block;
  background-color: rgb(238, 238, 238);
}
span:hover {
  text-decoration: line-through;
  cursor: pointer;
}
.buttonm {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  display: block;
  width: 100%;
}
.topform {
  margin: auto;
  position: relative;
  top: 100px;
  max-width: 50%;
}

@media only screen and (max-width: 1200px) {
  .topform {
    max-width: 75%;
  }
}
@media only screen and (max-width: 768px) {
  .topform {
    max-width: 85%;
  }
}
input[type="text"],
select {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type="submit"] {
  width: 75%;
  background-color: #4caf50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
input[type="submit"]:hover {
  background-color: #45a049;
}

div {
  border-radius: 5px;
  background-color: #fdfdfd;
}
</style>
